import { isDemoMode } from './supabase'

export function DemoNotice() {
  if (!isDemoMode) return null
  return (
    <div className="mb-4 p-3 rounded-lg border border-amber-200 bg-amber-50 text-amber-900 text-sm">
      Supabase isn't configured. Copy <code>.env.example</code> to <code>.env</code> and add your project credentials,
      then run the SQL files in <code>db/</code> to bring this page to life.
    </div>
  )
}
